import { getCredentiTokenHeaders, getBaseUrl } from "./ApiUrls";

const base_url = getBaseUrl();

export default {

    async get(path: string, params?: object, retries: number = 1, delay: number = 1000): Promise<any> {
        const requestOptions = {
            method: 'GET',
            headers: getCredentiTokenHeaders(),
        };

        const url = new URL(`${base_url}/${path}`);
        if (params) {
            Object.keys(params).forEach(key => url.searchParams.append(key, params[key]));
        }

        return fetch(url, requestOptions)
            .then(res => res.json())
    },

    post(path: string, data?: object, params?: object, retries: number = 1, delay: number = 1000): Promise<any> {
        var requestOptions = {
            method: 'POST',
            headers: getCredentiTokenHeaders(),
            body: JSON.stringify(data)
        }

        var url = new URL(`${base_url}/${path}`);
        if (params) {
            Object.keys(params).forEach(key => url.searchParams.append(key, params[key]));
        }

        return fetch(url, requestOptions)
            .then(res => res.json())
    },

    put(path: string, data: object, retries: number = 1, delay: number = 1000): Promise<any> {
        var requestOptions = {
            method: 'PUT',
            headers: getCredentiTokenHeaders(),
            body: JSON.stringify(data)
        }

        var url = new URL(`${base_url}/${path}`);

        return fetch(url, requestOptions)
            .then(res => res.json())
    },

    delete(path: string, data?: object, params?: object, retries: number = 1, delay: number = 1000): Promise<any> {
        var requestOptions = {
            method: 'DELETE',
            headers: getCredentiTokenHeaders(),
            body: JSON.stringify(data)
        }

        var url = new URL(`${base_url}/${path}`);
        if (params) {
            Object.keys(params).forEach(key => url.searchParams.append(key, params[key]));
        }

        return fetch(url, requestOptions)
            .then(res => res.json())
    }
}
